import { render, staticRenderFns } from "./BreadcrumbV2.vue?vue&type=template&id=77c35163&scoped=true"
import script from "./BreadcrumbV2.vue?vue&type=script&lang=js"
export * from "./BreadcrumbV2.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbV2.vue?vue&type=style&index=0&id=77c35163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c35163",
  null
  
)

export default component.exports